/*! active-profile 1.44.0 */
import { initializeStore as H, SeamlessConnection as Or, PersistentConnection as Rr } from "@seamless/store";
import { initializeLogger as kt } from "@seamless/logger";
const wr = (t) => {
  const e = typeof t;
  return t !== null && (e === "object" || e === "function");
}, Be = /* @__PURE__ */ new Set([
  "__proto__",
  "prototype",
  "constructor"
]), br = new Set("0123456789");
function Ar(t) {
  const e = [];
  let r = "", n = "start", s = !1;
  for (const i of t)
    switch (i) {
      case "\\":
        if (n === "index")
          throw new Error("Invalid character in an index");
        if (n === "indexEnd")
          throw new Error("Invalid character after an index");
        s && (r += i), n = "property", s = !s;
        break;
      case ".":
        if (n === "index")
          throw new Error("Invalid character in an index");
        if (n === "indexEnd") {
          n = "property";
          break;
        }
        if (s) {
          s = !1, r += i;
          break;
        }
        if (Be.has(r))
          return [];
        e.push(r), r = "", n = "property";
        break;
      case "[":
        if (n === "index")
          throw new Error("Invalid character in an index");
        if (n === "indexEnd") {
          n = "index";
          break;
        }
        if (s) {
          s = !1, r += i;
          break;
        }
        if (n === "property") {
          if (Be.has(r))
            return [];
          e.push(r), r = "";
        }
        n = "index";
        break;
      case "]":
        if (n === "index") {
          e.push(Number.parseInt(r, 10)), r = "", n = "indexEnd";
          break;
        }
        if (n === "indexEnd")
          throw new Error("Invalid character after an index");
      default:
        if (n === "index" && !br.has(i))
          throw new Error("Invalid character in an index");
        if (n === "indexEnd")
          throw new Error("Invalid character after an index");
        n === "start" && (n = "property"), s && (s = !1, r += "\\"), r += i;
    }
  switch (s && (r += "\\"), n) {
    case "property": {
      if (Be.has(r))
        return [];
      e.push(r);
      break;
    }
    case "index":
      throw new Error("Index was not closed");
    case "start": {
      e.push("");
      break;
    }
  }
  return e;
}
function Cr(t, e) {
  if (typeof e != "number" && Array.isArray(t)) {
    const r = Number.parseInt(e, 10);
    return Number.isInteger(r) && t[r] === t[e];
  }
  return !1;
}
function Sr(t, e, r) {
  if (!wr(t) || typeof e != "string")
    return r === void 0 ? t : r;
  const n = Ar(e);
  if (n.length === 0)
    return r;
  for (let s = 0; s < n.length; s++) {
    const i = n[s];
    if (Cr(t, i) ? t = s === n.length - 1 ? void 0 : null : t = t[i], t == null) {
      if (s !== n.length - 1)
        return r;
      break;
    }
  }
  return t === void 0 ? r : t;
}
const Y = {
  B2C: "B2C",
  B2B: "B2B"
}, N = "B2X_ACTIVE_PROFILE", h = {
  SET_COMPANY: "SET_COMPANY",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  SET_USER: "SET_USER",
  SET_FLEETS: "SET_FLEETS",
  SET_VEHICLES: "SET_VEHICLES",
  SET_VEHICLE_COUNT: "SET_VEHICLE_COUNT",
  SET_ROLES: "SET_ROLES",
  SET_ACTION_PERMISSIONS: "SET_ACTION_PERMISSIONS",
  SET_SERVICE_PERMISSIONS: "SET_SERVICE_PERMISSIONS",
  SET_ENTITY_PERMISSIONS: "SET_ENTITY_PERMISSIONS",
  SET_USER_JOURNEY_CACHE: "SET_USER_JOURNEY_CACHE",
  REGENERATE_USER_JOURNEY_CACHE: "REGENERATE_USER_JOURNEY_CACHE",
  SET_ACTIVE_COSTUMER_GROUP: "SET_ACTIVE_COSTUMER_GROUP",
  SET_STATE: "SET_STATE",
  RESET_STATE: "RESET_STATE",
  ENSURE_PROPERTIES: "ENSURE_PROPERTIES"
}, G = () => ({
  fleets: [],
  vehicles: [],
  roles: [],
  userJourneyCache: {},
  permissions: {
    actionPermissions: [],
    servicePermissions: [],
    entityPermissions: []
  },
  ensureProperties: [],
  meta: {
    version: "1.44.0",
    status: "INITIALIZING",
    actionPermissions: []
  }
});
function Tr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var zt = { exports: {} }, nt = { exports: {} }, Jt = function(e, r) {
  return function() {
    for (var s = new Array(arguments.length), i = 0; i < s.length; i++)
      s[i] = arguments[i];
    return e.apply(r, s);
  };
}, _r = Jt, st = Object.prototype.toString, it = function(t) {
  return function(e) {
    var r = st.call(e);
    return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function Q(t) {
  return t = t.toLowerCase(), function(r) {
    return it(r) === t;
  };
}
function at(t) {
  return Array.isArray(t);
}
function Oe(t) {
  return typeof t > "u";
}
function Ur(t) {
  return t !== null && !Oe(t) && t.constructor !== null && !Oe(t.constructor) && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
var Gt = Q("ArrayBuffer");
function Nr(t) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Gt(t.buffer), e;
}
function Br(t) {
  return typeof t == "string";
}
function xr(t) {
  return typeof t == "number";
}
function Yt(t) {
  return t !== null && typeof t == "object";
}
function ye(t) {
  if (it(t) !== "object")
    return !1;
  var e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
var jr = Q("Date"), Vr = Q("File"), Ir = Q("Blob"), Dr = Q("FileList");
function ot(t) {
  return st.call(t) === "[object Function]";
}
function Lr(t) {
  return Yt(t) && ot(t.pipe);
}
function qr(t) {
  var e = "[object FormData]";
  return t && (typeof FormData == "function" && t instanceof FormData || st.call(t) === e || ot(t.toString) && t.toString() === e);
}
var $r = Q("URLSearchParams");
function Fr(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
function Mr() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function ct(t, e) {
  if (!(t === null || typeof t > "u"))
    if (typeof t != "object" && (t = [t]), at(t))
      for (var r = 0, n = t.length; r < n; r++)
        e.call(null, t[r], r, t);
    else
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && e.call(null, t[s], s, t);
}
function Ze() {
  var t = {};
  function e(s, i) {
    ye(t[i]) && ye(s) ? t[i] = Ze(t[i], s) : ye(s) ? t[i] = Ze({}, s) : at(s) ? t[i] = s.slice() : t[i] = s;
  }
  for (var r = 0, n = arguments.length; r < n; r++)
    ct(arguments[r], e);
  return t;
}
function Hr(t, e, r) {
  return ct(e, function(s, i) {
    r && typeof s == "function" ? t[i] = _r(s, r) : t[i] = s;
  }), t;
}
function kr(t) {
  return t.charCodeAt(0) === 65279 && (t = t.slice(1)), t;
}
function zr(t, e, r, n) {
  t.prototype = Object.create(e.prototype, n), t.prototype.constructor = t, r && Object.assign(t.prototype, r);
}
function Jr(t, e, r) {
  var n, s, i, a = {};
  e = e || {};
  do {
    for (n = Object.getOwnPropertyNames(t), s = n.length; s-- > 0; )
      i = n[s], a[i] || (e[i] = t[i], a[i] = !0);
    t = Object.getPrototypeOf(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}
function Gr(t, e, r) {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  var n = t.indexOf(e, r);
  return n !== -1 && n === r;
}
function Yr(t) {
  if (!t)
    return null;
  var e = t.length;
  if (Oe(e))
    return null;
  for (var r = new Array(e); e-- > 0; )
    r[e] = t[e];
  return r;
}
var Qr = function(t) {
  return function(e) {
    return t && e instanceof t;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), O = {
  isArray: at,
  isArrayBuffer: Gt,
  isBuffer: Ur,
  isFormData: qr,
  isArrayBufferView: Nr,
  isString: Br,
  isNumber: xr,
  isObject: Yt,
  isPlainObject: ye,
  isUndefined: Oe,
  isDate: jr,
  isFile: Vr,
  isBlob: Ir,
  isFunction: ot,
  isStream: Lr,
  isURLSearchParams: $r,
  isStandardBrowserEnv: Mr,
  forEach: ct,
  merge: Ze,
  extend: Hr,
  trim: Fr,
  stripBOM: kr,
  inherits: zr,
  toFlatObject: Jr,
  kindOf: it,
  kindOfTest: Q,
  endsWith: Gr,
  toArray: Yr,
  isTypedArray: Qr,
  isFileList: Dr
}, W = O;
function vt(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Qt = function(e, r, n) {
  if (!r)
    return e;
  var s;
  if (n)
    s = n(r);
  else if (W.isURLSearchParams(r))
    s = r.toString();
  else {
    var i = [];
    W.forEach(r, function(c, u) {
      c === null || typeof c > "u" || (W.isArray(c) ? u = u + "[]" : c = [c], W.forEach(c, function(f) {
        W.isDate(f) ? f = f.toISOString() : W.isObject(f) && (f = JSON.stringify(f)), i.push(vt(u) + "=" + vt(f));
      }));
    }), s = i.join("&");
  }
  if (s) {
    var a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}, Xr = O;
function be() {
  this.handlers = [];
}
be.prototype.use = function(e, r, n) {
  return this.handlers.push({
    fulfilled: e,
    rejected: r,
    synchronous: n ? n.synchronous : !1,
    runWhen: n ? n.runWhen : null
  }), this.handlers.length - 1;
};
be.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
be.prototype.forEach = function(e) {
  Xr.forEach(this.handlers, function(n) {
    n !== null && e(n);
  });
};
var Wr = be, Kr = O, Zr = function(e, r) {
  Kr.forEach(e, function(s, i) {
    i !== r && i.toUpperCase() === r.toUpperCase() && (e[r] = s, delete e[i]);
  });
}, Xt = O;
function ie(t, e, r, n, s) {
  Error.call(this), this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), n && (this.request = n), s && (this.response = s);
}
Xt.inherits(ie, Error, {
  toJSON: function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var Wt = ie.prototype, Kt = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
].forEach(function(t) {
  Kt[t] = { value: t };
});
Object.defineProperties(ie, Kt);
Object.defineProperty(Wt, "isAxiosError", { value: !0 });
ie.from = function(t, e, r, n, s, i) {
  var a = Object.create(Wt);
  return Xt.toFlatObject(t, a, function(c) {
    return c !== Error.prototype;
  }), ie.call(a, t.message, e, r, n, s), a.name = t.name, i && Object.assign(a, i), a;
};
var oe = ie, Zt = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, U = O;
function en(t, e) {
  e = e || new FormData();
  var r = [];
  function n(i) {
    return i === null ? "" : U.isDate(i) ? i.toISOString() : U.isArrayBuffer(i) || U.isTypedArray(i) ? typeof Blob == "function" ? new Blob([i]) : Buffer.from(i) : i;
  }
  function s(i, a) {
    if (U.isPlainObject(i) || U.isArray(i)) {
      if (r.indexOf(i) !== -1)
        throw Error("Circular reference detected in " + a);
      r.push(i), U.forEach(i, function(c, u) {
        if (!U.isUndefined(c)) {
          var l = a ? a + "." + u : u, f;
          if (c && !a && typeof c == "object") {
            if (U.endsWith(u, "{}"))
              c = JSON.stringify(c);
            else if (U.endsWith(u, "[]") && (f = U.toArray(c))) {
              f.forEach(function(d) {
                !U.isUndefined(d) && e.append(l, n(d));
              });
              return;
            }
          }
          s(c, l);
        }
      }), r.pop();
    } else
      e.append(a, n(i));
  }
  return s(t), e;
}
var er = en, xe, Et;
function tn() {
  if (Et)
    return xe;
  Et = 1;
  var t = oe;
  return xe = function(r, n, s) {
    var i = s.config.validateStatus;
    !s.status || !i || i(s.status) ? r(s) : n(new t(
      "Request failed with status code " + s.status,
      [t.ERR_BAD_REQUEST, t.ERR_BAD_RESPONSE][Math.floor(s.status / 100) - 4],
      s.config,
      s.request,
      s
    ));
  }, xe;
}
var je, yt;
function rn() {
  if (yt)
    return je;
  yt = 1;
  var t = O;
  return je = t.isStandardBrowserEnv() ? function() {
    return {
      write: function(n, s, i, a, o, c) {
        var u = [];
        u.push(n + "=" + encodeURIComponent(s)), t.isNumber(i) && u.push("expires=" + new Date(i).toGMTString()), t.isString(a) && u.push("path=" + a), t.isString(o) && u.push("domain=" + o), c === !0 && u.push("secure"), document.cookie = u.join("; ");
      },
      read: function(n) {
        var s = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return s ? decodeURIComponent(s[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }() : function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }(), je;
}
var nn = function(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}, sn = function(e, r) {
  return r ? e.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : e;
}, an = nn, on = sn, tr = function(e, r) {
  return e && !an(r) ? on(e, r) : r;
}, Ve, Pt;
function cn() {
  if (Pt)
    return Ve;
  Pt = 1;
  var t = O, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return Ve = function(n) {
    var s = {}, i, a, o;
    return n && t.forEach(n.split(`
`), function(u) {
      if (o = u.indexOf(":"), i = t.trim(u.substr(0, o)).toLowerCase(), a = t.trim(u.substr(o + 1)), i) {
        if (s[i] && e.indexOf(i) >= 0)
          return;
        i === "set-cookie" ? s[i] = (s[i] ? s[i] : []).concat([a]) : s[i] = s[i] ? s[i] + ", " + a : a;
      }
    }), s;
  }, Ve;
}
var Ie, gt;
function un() {
  if (gt)
    return Ie;
  gt = 1;
  var t = O;
  return Ie = t.isStandardBrowserEnv() ? function() {
    var r = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), s;
    function i(a) {
      var o = a;
      return r && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return s = i(window.location.href), function(o) {
      var c = t.isString(o) ? i(o) : o;
      return c.protocol === s.protocol && c.host === s.host;
    };
  }() : function() {
    return function() {
      return !0;
    };
  }(), Ie;
}
var De, Ot;
function Ae() {
  if (Ot)
    return De;
  Ot = 1;
  var t = oe, e = O;
  function r(n) {
    t.call(this, n == null ? "canceled" : n, t.ERR_CANCELED), this.name = "CanceledError";
  }
  return e.inherits(r, t, {
    __CANCEL__: !0
  }), De = r, De;
}
var Le, Rt;
function ln() {
  return Rt || (Rt = 1, Le = function(e) {
    var r = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return r && r[1] || "";
  }), Le;
}
var qe, wt;
function bt() {
  if (wt)
    return qe;
  wt = 1;
  var t = O, e = tn(), r = rn(), n = Qt, s = tr, i = cn(), a = un(), o = Zt, c = oe, u = Ae(), l = ln();
  return qe = function(d) {
    return new Promise(function(k, A) {
      var x = d.data, C = d.headers, B = d.responseType, v;
      function T() {
        d.cancelToken && d.cancelToken.unsubscribe(v), d.signal && d.signal.removeEventListener("abort", v);
      }
      t.isFormData(x) && t.isStandardBrowserEnv() && delete C["Content-Type"];
      var p = new XMLHttpRequest();
      if (d.auth) {
        var ce = d.auth.username || "", ue = d.auth.password ? unescape(encodeURIComponent(d.auth.password)) : "";
        C.Authorization = "Basic " + btoa(ce + ":" + ue);
      }
      var _e = s(d.baseURL, d.url);
      p.open(d.method.toUpperCase(), n(_e, d.params, d.paramsSerializer), !0), p.timeout = d.timeout;
      function ht() {
        if (!!p) {
          var _ = "getAllResponseHeaders" in p ? i(p.getAllResponseHeaders()) : null, X = !B || B === "text" || B === "json" ? p.responseText : p.response, z = {
            data: X,
            status: p.status,
            statusText: p.statusText,
            headers: _,
            config: d,
            request: p
          };
          e(function(Ne) {
            k(Ne), T();
          }, function(Ne) {
            A(Ne), T();
          }, z), p = null;
        }
      }
      if ("onloadend" in p ? p.onloadend = ht : p.onreadystatechange = function() {
        !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(ht);
      }, p.onabort = function() {
        !p || (A(new c("Request aborted", c.ECONNABORTED, d, p)), p = null);
      }, p.onerror = function() {
        A(new c("Network Error", c.ERR_NETWORK, d, p, p)), p = null;
      }, p.ontimeout = function() {
        var X = d.timeout ? "timeout of " + d.timeout + "ms exceeded" : "timeout exceeded", z = d.transitional || o;
        d.timeoutErrorMessage && (X = d.timeoutErrorMessage), A(new c(
          X,
          z.clarifyTimeoutError ? c.ETIMEDOUT : c.ECONNABORTED,
          d,
          p
        )), p = null;
      }, t.isStandardBrowserEnv()) {
        var mt = (d.withCredentials || a(_e)) && d.xsrfCookieName ? r.read(d.xsrfCookieName) : void 0;
        mt && (C[d.xsrfHeaderName] = mt);
      }
      "setRequestHeader" in p && t.forEach(C, function(X, z) {
        typeof x > "u" && z.toLowerCase() === "content-type" ? delete C[z] : p.setRequestHeader(z, X);
      }), t.isUndefined(d.withCredentials) || (p.withCredentials = !!d.withCredentials), B && B !== "json" && (p.responseType = d.responseType), typeof d.onDownloadProgress == "function" && p.addEventListener("progress", d.onDownloadProgress), typeof d.onUploadProgress == "function" && p.upload && p.upload.addEventListener("progress", d.onUploadProgress), (d.cancelToken || d.signal) && (v = function(_) {
        !p || (A(!_ || _ && _.type ? new u() : _), p.abort(), p = null);
      }, d.cancelToken && d.cancelToken.subscribe(v), d.signal && (d.signal.aborted ? v() : d.signal.addEventListener("abort", v))), x || (x = null);
      var Ue = l(_e);
      if (Ue && ["http", "https", "file"].indexOf(Ue) === -1) {
        A(new c("Unsupported protocol " + Ue + ":", c.ERR_BAD_REQUEST, d));
        return;
      }
      p.send(x);
    });
  }, qe;
}
var $e, At;
function dn() {
  return At || (At = 1, $e = null), $e;
}
var E = O, Ct = Zr, St = oe, fn = Zt, pn = er, hn = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function Tt(t, e) {
  !E.isUndefined(t) && E.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
}
function mn() {
  var t;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (t = bt()), t;
}
function vn(t, e, r) {
  if (E.isString(t))
    try {
      return (e || JSON.parse)(t), E.trim(t);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(t);
}
var Ce = {
  transitional: fn,
  adapter: mn(),
  transformRequest: [function(e, r) {
    if (Ct(r, "Accept"), Ct(r, "Content-Type"), E.isFormData(e) || E.isArrayBuffer(e) || E.isBuffer(e) || E.isStream(e) || E.isFile(e) || E.isBlob(e))
      return e;
    if (E.isArrayBufferView(e))
      return e.buffer;
    if (E.isURLSearchParams(e))
      return Tt(r, "application/x-www-form-urlencoded;charset=utf-8"), e.toString();
    var n = E.isObject(e), s = r && r["Content-Type"], i;
    if ((i = E.isFileList(e)) || n && s === "multipart/form-data") {
      var a = this.env && this.env.FormData;
      return pn(i ? { "files[]": e } : e, a && new a());
    } else if (n || s === "application/json")
      return Tt(r, "application/json"), vn(e);
    return e;
  }],
  transformResponse: [function(e) {
    var r = this.transitional || Ce.transitional, n = r && r.silentJSONParsing, s = r && r.forcedJSONParsing, i = !n && this.responseType === "json";
    if (i || s && E.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (a) {
        if (i)
          throw a.name === "SyntaxError" ? St.from(a, St.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    return e;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: dn()
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
E.forEach(["delete", "get", "head"], function(e) {
  Ce.headers[e] = {};
});
E.forEach(["post", "put", "patch"], function(e) {
  Ce.headers[e] = E.merge(hn);
});
var ut = Ce, En = O, yn = ut, Pn = function(e, r, n) {
  var s = this || yn;
  return En.forEach(n, function(a) {
    e = a.call(s, e, r);
  }), e;
}, Fe, _t;
function rr() {
  return _t || (_t = 1, Fe = function(e) {
    return !!(e && e.__CANCEL__);
  }), Fe;
}
var Ut = O, Me = Pn, gn = rr(), On = ut, Rn = Ae();
function He(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Rn();
}
var wn = function(e) {
  He(e), e.headers = e.headers || {}, e.data = Me.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = Ut.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), Ut.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(s) {
      delete e.headers[s];
    }
  );
  var r = e.adapter || On.adapter;
  return r(e).then(function(s) {
    return He(e), s.data = Me.call(
      e,
      s.data,
      s.headers,
      e.transformResponse
    ), s;
  }, function(s) {
    return gn(s) || (He(e), s && s.response && (s.response.data = Me.call(
      e,
      s.response.data,
      s.response.headers,
      e.transformResponse
    ))), Promise.reject(s);
  });
}, b = O, nr = function(e, r) {
  r = r || {};
  var n = {};
  function s(l, f) {
    return b.isPlainObject(l) && b.isPlainObject(f) ? b.merge(l, f) : b.isPlainObject(f) ? b.merge({}, f) : b.isArray(f) ? f.slice() : f;
  }
  function i(l) {
    if (b.isUndefined(r[l])) {
      if (!b.isUndefined(e[l]))
        return s(void 0, e[l]);
    } else
      return s(e[l], r[l]);
  }
  function a(l) {
    if (!b.isUndefined(r[l]))
      return s(void 0, r[l]);
  }
  function o(l) {
    if (b.isUndefined(r[l])) {
      if (!b.isUndefined(e[l]))
        return s(void 0, e[l]);
    } else
      return s(void 0, r[l]);
  }
  function c(l) {
    if (l in r)
      return s(e[l], r[l]);
    if (l in e)
      return s(void 0, e[l]);
  }
  var u = {
    url: a,
    method: a,
    data: a,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: c
  };
  return b.forEach(Object.keys(e).concat(Object.keys(r)), function(f) {
    var d = u[f] || i, m = d(f);
    b.isUndefined(m) && d !== c || (n[f] = m);
  }), n;
}, ke, Nt;
function sr() {
  return Nt || (Nt = 1, ke = {
    version: "0.27.2"
  }), ke;
}
sr().version;
var I = oe, lt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(t, e) {
  lt[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
var Bt = {};
lt.transitional = function(e, r, n) {
  function s(i, a) {
    return "[Axios v1.44.0] Transitional option '" + i + "'" + a + (n ? ". " + n : "");
  }
  return function(i, a, o) {
    if (e === !1)
      throw new I(
        s(a, " has been removed" + (r ? " in " + r : "")),
        I.ERR_DEPRECATED
      );
    return r && !Bt[a] && (Bt[a] = !0, console.warn(
      s(
        a,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(i, a, o) : !0;
  };
};
function bn(t, e, r) {
  if (typeof t != "object")
    throw new I("options must be an object", I.ERR_BAD_OPTION_VALUE);
  for (var n = Object.keys(t), s = n.length; s-- > 0; ) {
    var i = n[s], a = e[i];
    if (a) {
      var o = t[i], c = o === void 0 || a(o, i, t);
      if (c !== !0)
        throw new I("option " + i + " must be " + c, I.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new I("Unknown option " + i, I.ERR_BAD_OPTION);
  }
}
var An = {
  assertOptions: bn,
  validators: lt
}, ir = O, Cn = Qt, xt = Wr, jt = wn, Se = nr, Sn = tr, ar = An, K = ar.validators;
function ae(t) {
  this.defaults = t, this.interceptors = {
    request: new xt(),
    response: new xt()
  };
}
ae.prototype.request = function(e, r) {
  typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = Se(this.defaults, r), r.method ? r.method = r.method.toLowerCase() : this.defaults.method ? r.method = this.defaults.method.toLowerCase() : r.method = "get";
  var n = r.transitional;
  n !== void 0 && ar.assertOptions(n, {
    silentJSONParsing: K.transitional(K.boolean),
    forcedJSONParsing: K.transitional(K.boolean),
    clarifyTimeoutError: K.transitional(K.boolean)
  }, !1);
  var s = [], i = !0;
  this.interceptors.request.forEach(function(m) {
    typeof m.runWhen == "function" && m.runWhen(r) === !1 || (i = i && m.synchronous, s.unshift(m.fulfilled, m.rejected));
  });
  var a = [];
  this.interceptors.response.forEach(function(m) {
    a.push(m.fulfilled, m.rejected);
  });
  var o;
  if (!i) {
    var c = [jt, void 0];
    for (Array.prototype.unshift.apply(c, s), c = c.concat(a), o = Promise.resolve(r); c.length; )
      o = o.then(c.shift(), c.shift());
    return o;
  }
  for (var u = r; s.length; ) {
    var l = s.shift(), f = s.shift();
    try {
      u = l(u);
    } catch (d) {
      f(d);
      break;
    }
  }
  try {
    o = jt(u);
  } catch (d) {
    return Promise.reject(d);
  }
  for (; a.length; )
    o = o.then(a.shift(), a.shift());
  return o;
};
ae.prototype.getUri = function(e) {
  e = Se(this.defaults, e);
  var r = Sn(e.baseURL, e.url);
  return Cn(r, e.params, e.paramsSerializer);
};
ir.forEach(["delete", "get", "head", "options"], function(e) {
  ae.prototype[e] = function(r, n) {
    return this.request(Se(n || {}, {
      method: e,
      url: r,
      data: (n || {}).data
    }));
  };
});
ir.forEach(["post", "put", "patch"], function(e) {
  function r(n) {
    return function(i, a, o) {
      return this.request(Se(o || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  ae.prototype[e] = r(), ae.prototype[e + "Form"] = r(!0);
});
var Tn = ae, ze, Vt;
function _n() {
  if (Vt)
    return ze;
  Vt = 1;
  var t = Ae();
  function e(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    var s = this;
    this.promise.then(function(i) {
      if (!!s._listeners) {
        var a, o = s._listeners.length;
        for (a = 0; a < o; a++)
          s._listeners[a](i);
        s._listeners = null;
      }
    }), this.promise.then = function(i) {
      var a, o = new Promise(function(c) {
        s.subscribe(c), a = c;
      }).then(i);
      return o.cancel = function() {
        s.unsubscribe(a);
      }, o;
    }, r(function(a) {
      s.reason || (s.reason = new t(a), n(s.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.prototype.subscribe = function(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }, e.prototype.unsubscribe = function(n) {
    if (!!this._listeners) {
      var s = this._listeners.indexOf(n);
      s !== -1 && this._listeners.splice(s, 1);
    }
  }, e.source = function() {
    var n, s = new e(function(a) {
      n = a;
    });
    return {
      token: s,
      cancel: n
    };
  }, ze = e, ze;
}
var Je, It;
function Un() {
  return It || (It = 1, Je = function(e) {
    return function(n) {
      return e.apply(null, n);
    };
  }), Je;
}
var Ge, Dt;
function Nn() {
  if (Dt)
    return Ge;
  Dt = 1;
  var t = O;
  return Ge = function(r) {
    return t.isObject(r) && r.isAxiosError === !0;
  }, Ge;
}
var Lt = O, Bn = Jt, Pe = Tn, xn = nr, jn = ut;
function or(t) {
  var e = new Pe(t), r = Bn(Pe.prototype.request, e);
  return Lt.extend(r, Pe.prototype, e), Lt.extend(r, e), r.create = function(s) {
    return or(xn(t, s));
  }, r;
}
var w = or(jn);
w.Axios = Pe;
w.CanceledError = Ae();
w.CancelToken = _n();
w.isCancel = rr();
w.VERSION = sr().version;
w.toFormData = er;
w.AxiosError = oe;
w.Cancel = w.CanceledError;
w.all = function(e) {
  return Promise.all(e);
};
w.spread = Un();
w.isAxiosError = Nn();
nt.exports = w;
nt.exports.default = w;
(function(t) {
  t.exports = nt.exports;
})(zt);
const g = /* @__PURE__ */ Tr(zt.exports), J = "http://localhost".replace(/\/+$/, "");
class cr {
  constructor(e, r = J, n = g) {
    this.basePath = r, this.axios = n, e && (this.configuration = e, this.basePath = e.basePath || this.basePath);
  }
}
class Vn extends Error {
  constructor(e, r) {
    super(r), this.field = e, this.name = "RequiredError";
  }
}
globalThis && globalThis.__awaiter;
const Z = "https://example.com", le = function(t, e, r) {
  if (r == null)
    throw new Vn(e, `Required parameter ${e} was null or undefined when calling ${t}.`);
};
function et(t, e, r = "") {
  e != null && (typeof e == "object" ? Array.isArray(e) ? e.forEach((n) => et(t, n, r)) : Object.keys(e).forEach((n) => et(t, e[n], `${r}${r !== "" ? "." : ""}${n}`)) : t.has(r) ? t.append(r, e) : t.set(r, e));
}
const ee = function(t, ...e) {
  const r = new URLSearchParams(t.search);
  et(r, e), t.search = r.toString();
}, te = function(t, e, r) {
  const n = typeof t != "string";
  return (n && r && r.isJsonMime ? r.isJsonMime(e.headers["Content-Type"]) : n) ? JSON.stringify(t !== void 0 ? t : {}) : t || "";
}, re = function(t) {
  return t.pathname + t.search + t.hash;
}, ne = function(t, e, r, n) {
  return (s = e, i = r) => {
    const a = Object.assign(Object.assign({}, t.options), { url: ((n == null ? void 0 : n.basePath) || i) + t.url });
    return s.request(a);
  };
};
var S = globalThis && globalThis.__awaiter || function(t, e, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function o(l) {
      try {
        u(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? i(l.value) : s(l.value).then(o, c);
    }
    u((n = n.apply(t, e || [])).next());
  });
};
const In = function(t) {
  return {
    createUpdateDeleteCompanies: (e, r = {}) => S(this, void 0, void 0, function* () {
      le("createUpdateDeleteCompanies", "companyCUDRequest", e);
      const n = "/companies", s = new URL(n, Z);
      let i;
      t && (i = t.baseOptions);
      const a = Object.assign(Object.assign({ method: "PATCH" }, i), r), o = {}, c = {};
      o["Content-Type"] = "application/json", ee(s, c);
      let u = i && i.headers ? i.headers : {};
      return a.headers = Object.assign(Object.assign(Object.assign({}, o), u), r.headers), a.data = te(e, a, t), {
        url: re(s),
        options: a
      };
    }),
    createUpdateDeleteViewCompanies: (e, r = {}) => S(this, void 0, void 0, function* () {
      le("createUpdateDeleteViewCompanies", "viewCompanyCUDRequest", e);
      const n = "/view-companies", s = new URL(n, Z);
      let i;
      t && (i = t.baseOptions);
      const a = Object.assign(Object.assign({ method: "PATCH" }, i), r), o = {}, c = {};
      o["Content-Type"] = "application/json", ee(s, c);
      let u = i && i.headers ? i.headers : {};
      return a.headers = Object.assign(Object.assign(Object.assign({}, o), u), r.headers), a.data = te(e, a, t), {
        url: re(s),
        options: a
      };
    }),
    getCompanies: (e, r = {}) => S(this, void 0, void 0, function* () {
      le("getCompanies", "companyDataBatchRequest", e);
      const n = "/companies-fsp", s = new URL(n, Z);
      let i;
      t && (i = t.baseOptions);
      const a = Object.assign(Object.assign({ method: "POST" }, i), r), o = {}, c = {};
      o["Content-Type"] = "application/json", ee(s, c);
      let u = i && i.headers ? i.headers : {};
      return a.headers = Object.assign(Object.assign(Object.assign({}, o), u), r.headers), a.data = te(e, a, t), {
        url: re(s),
        options: a
      };
    }),
    getCompany: (e, r = {}) => S(this, void 0, void 0, function* () {
      le("getCompany", "company", e);
      const n = "/companies", s = new URL(n, Z);
      let i;
      t && (i = t.baseOptions);
      const a = Object.assign(Object.assign({ method: "POST" }, i), r), o = {}, c = {};
      o["Content-Type"] = "application/json", ee(s, c);
      let u = i && i.headers ? i.headers : {};
      return a.headers = Object.assign(Object.assign(Object.assign({}, o), u), r.headers), a.data = te(e, a, t), {
        url: re(s),
        options: a
      };
    }),
    getViewCompanies: (e, r = {}) => S(this, void 0, void 0, function* () {
      le("getViewCompanies", "viewCompanyFSPBatchRequest", e);
      const n = "/view-companies", s = new URL(n, Z);
      let i;
      t && (i = t.baseOptions);
      const a = Object.assign(Object.assign({ method: "POST" }, i), r), o = {}, c = {};
      o["Content-Type"] = "application/json", ee(s, c);
      let u = i && i.headers ? i.headers : {};
      return a.headers = Object.assign(Object.assign(Object.assign({}, o), u), r.headers), a.data = te(e, a, t), {
        url: re(s),
        options: a
      };
    })
  };
}, de = function(t) {
  const e = In(t);
  return {
    createUpdateDeleteCompanies(r, n) {
      return S(this, void 0, void 0, function* () {
        const s = yield e.createUpdateDeleteCompanies(r, n);
        return ne(s, g, J, t);
      });
    },
    createUpdateDeleteViewCompanies(r, n) {
      return S(this, void 0, void 0, function* () {
        const s = yield e.createUpdateDeleteViewCompanies(r, n);
        return ne(s, g, J, t);
      });
    },
    getCompanies(r, n) {
      return S(this, void 0, void 0, function* () {
        const s = yield e.getCompanies(r, n);
        return ne(s, g, J, t);
      });
    },
    getCompany(r, n) {
      return S(this, void 0, void 0, function* () {
        const s = yield e.getCompany(r, n);
        return ne(s, g, J, t);
      });
    },
    getViewCompanies(r, n) {
      return S(this, void 0, void 0, function* () {
        const s = yield e.getViewCompanies(r, n);
        return ne(s, g, J, t);
      });
    }
  };
};
class Dn extends cr {
  createUpdateDeleteCompanies(e, r) {
    return de(this.configuration).createUpdateDeleteCompanies(e, r).then((n) => n(this.axios, this.basePath));
  }
  createUpdateDeleteViewCompanies(e, r) {
    return de(this.configuration).createUpdateDeleteViewCompanies(e, r).then((n) => n(this.axios, this.basePath));
  }
  getCompanies(e, r) {
    return de(this.configuration).getCompanies(e, r).then((n) => n(this.axios, this.basePath));
  }
  getCompany(e, r) {
    return de(this.configuration).getCompany(e, r).then((n) => n(this.axios, this.basePath));
  }
  getViewCompanies(e, r) {
    return de(this.configuration).getViewCompanies(e, r).then((n) => n(this.axios, this.basePath));
  }
}
const Ln = function(t) {
  return {
    getProfiles: (e, r = {}) => S(this, void 0, void 0, function* () {
      const n = "/profiles", s = new URL(n, Z);
      let i;
      t && (i = t.baseOptions);
      const a = Object.assign(Object.assign({ method: "POST" }, i), r), o = {}, c = {};
      o["Content-Type"] = "application/json", ee(s, c);
      let u = i && i.headers ? i.headers : {};
      return a.headers = Object.assign(Object.assign(Object.assign({}, o), u), r.headers), a.data = te(e, a, t), {
        url: re(s),
        options: a
      };
    })
  };
}, qn = function(t) {
  const e = Ln(t);
  return {
    getProfiles(r, n) {
      return S(this, void 0, void 0, function* () {
        const s = yield e.getProfiles(r, n);
        return ne(s, g, J, t);
      });
    }
  };
};
class $n extends cr {
  getProfiles(e, r) {
    return qn(this.configuration).getProfiles(e, r).then((n) => n(this.axios, this.basePath));
  }
}
class qt {
  constructor(e = {}) {
    this.apiKey = e.apiKey, this.username = e.username, this.password = e.password, this.accessToken = e.accessToken, this.basePath = e.basePath, this.baseOptions = e.baseOptions, this.formDataCtor = e.formDataCtor;
  }
  isJsonMime(e) {
    const r = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return e !== null && (r.test(e) || e.toLowerCase() === "application/json-patch+json");
  }
}
const j = "http://localhost".replace(/\/+$/, "");
class ur {
  constructor(e, r = j, n = g) {
    this.basePath = r, this.axios = n, e && (this.configuration = e, this.basePath = e.basePath || this.basePath);
  }
}
class Fn extends Error {
  constructor(e, r) {
    super(r), this.field = e, this.name = "RequiredError";
  }
}
var Mn = globalThis && globalThis.__awaiter || function(t, e, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function o(l) {
      try {
        u(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? i(l.value) : s(l.value).then(o, c);
    }
    u((n = n.apply(t, e || [])).next());
  });
};
const D = "https://example.com", ge = function(t, e, r) {
  if (r == null)
    throw new Fn(e, `Required parameter ${e} was null or undefined when calling ${t}.`);
}, Ye = function(t, e) {
  e && (e.username || e.password) && (t.auth = { username: e.username, password: e.password });
}, Qe = function(t, e) {
  return Mn(this, void 0, void 0, function* () {
    if (e && e.accessToken) {
      const r = typeof e.accessToken == "function" ? yield e.accessToken() : yield e.accessToken;
      t.Authorization = "Bearer " + r;
    }
  });
};
function tt(t, e, r = "") {
  e != null && (typeof e == "object" ? Array.isArray(e) ? e.forEach((n) => tt(t, n, r)) : Object.keys(e).forEach((n) => tt(t, e[n], `${r}${r !== "" ? "." : ""}${n}`)) : t.has(r) ? t.append(r, e) : t.set(r, e));
}
const L = function(t, ...e) {
  const r = new URLSearchParams(t.search);
  tt(r, e), t.search = r.toString();
}, Re = function(t, e, r) {
  const n = typeof t != "string";
  return (n && r && r.isJsonMime ? r.isJsonMime(e.headers["Content-Type"]) : n) ? JSON.stringify(t !== void 0 ? t : {}) : t || "";
}, q = function(t) {
  return t.pathname + t.search + t.hash;
}, $ = function(t, e, r, n) {
  return (s = e, i = r) => {
    const a = Object.assign(Object.assign({}, t.options), { url: ((n == null ? void 0 : n.basePath) || i) + t.url });
    return s.request(a);
  };
};
var R = globalThis && globalThis.__awaiter || function(t, e, r, n) {
  function s(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function o(l) {
      try {
        u(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? i(l.value) : s(l.value).then(o, c);
    }
    u((n = n.apply(t, e || [])).next());
  });
};
const Hn = function(t) {
  return {
    deleteCurrentActiveUserProfile: (e = {}) => R(this, void 0, void 0, function* () {
      const r = "/active-user-profile", n = new URL(r, D);
      let s;
      t && (s = t.baseOptions);
      const i = Object.assign(Object.assign({ method: "DELETE" }, s), e), a = {};
      L(n, {});
      let c = s && s.headers ? s.headers : {};
      return i.headers = Object.assign(Object.assign(Object.assign({}, a), c), e.headers), {
        url: q(n),
        options: i
      };
    }),
    getActiveUserProfile: (e, r = {}) => R(this, void 0, void 0, function* () {
      const n = "/get-active-user-profile", s = new URL(n, D);
      let i;
      t && (i = t.baseOptions);
      const a = Object.assign(Object.assign({ method: "POST" }, i), r), o = {}, c = {};
      o["Content-Type"] = "application/json", L(s, c);
      let u = i && i.headers ? i.headers : {};
      return a.headers = Object.assign(Object.assign(Object.assign({}, o), u), r.headers), a.data = Re(e, a, t), {
        url: q(s),
        options: a
      };
    }),
    saveCurrentActiveUserProfile: (e, r = {}) => R(this, void 0, void 0, function* () {
      ge("saveCurrentActiveUserProfile", "activeUserProfileRequest", e);
      const n = "/active-user-profile", s = new URL(n, D);
      let i;
      t && (i = t.baseOptions);
      const a = Object.assign(Object.assign({ method: "POST" }, i), r), o = {}, c = {};
      o["Content-Type"] = "application/json", L(s, c);
      let u = i && i.headers ? i.headers : {};
      return a.headers = Object.assign(Object.assign(Object.assign({}, o), u), r.headers), a.data = Re(e, a, t), {
        url: q(s),
        options: a
      };
    })
  };
}, Xe = function(t) {
  const e = Hn(t);
  return {
    deleteCurrentActiveUserProfile(r) {
      return R(this, void 0, void 0, function* () {
        const n = yield e.deleteCurrentActiveUserProfile(r);
        return $(n, g, j, t);
      });
    },
    getActiveUserProfile(r, n) {
      return R(this, void 0, void 0, function* () {
        const s = yield e.getActiveUserProfile(r, n);
        return $(s, g, j, t);
      });
    },
    saveCurrentActiveUserProfile(r, n) {
      return R(this, void 0, void 0, function* () {
        const s = yield e.saveCurrentActiveUserProfile(r, n);
        return $(s, g, j, t);
      });
    }
  };
};
class kn extends ur {
  deleteCurrentActiveUserProfile(e) {
    return Xe(this.configuration).deleteCurrentActiveUserProfile(e).then((r) => r(this.axios, this.basePath));
  }
  getActiveUserProfile(e, r) {
    return Xe(this.configuration).getActiveUserProfile(e, r).then((n) => n(this.axios, this.basePath));
  }
  saveCurrentActiveUserProfile(e, r) {
    return Xe(this.configuration).saveCurrentActiveUserProfile(e, r).then((n) => n(this.axios, this.basePath));
  }
}
const zn = function(t) {
  return {
    getConditions: (e = {}) => R(this, void 0, void 0, function* () {
      const r = "/authorization-schema/get-conditions", n = new URL(r, D);
      let s;
      t && (s = t.baseOptions);
      const i = Object.assign(Object.assign({ method: "GET" }, s), e), a = {}, o = {};
      Ye(i, t), yield Qe(a, t), L(n, o);
      let c = s && s.headers ? s.headers : {};
      return i.headers = Object.assign(Object.assign(Object.assign({}, a), c), e.headers), {
        url: q(n),
        options: i
      };
    }),
    getCurrentUserPermissions: (e, r = {}) => R(this, void 0, void 0, function* () {
      ge("getCurrentUserPermissions", "getUserPermissionsBatchRequest", e);
      const n = "/authorization/permissions", s = new URL(n, D);
      let i;
      t && (i = t.baseOptions);
      const a = Object.assign(Object.assign({ method: "POST" }, i), r), o = {}, c = {};
      o["Content-Type"] = "application/json", L(s, c);
      let u = i && i.headers ? i.headers : {};
      return a.headers = Object.assign(Object.assign(Object.assign({}, o), u), r.headers), a.data = Re(e, a, t), {
        url: q(s),
        options: a
      };
    }),
    getRoles: (e = {}) => R(this, void 0, void 0, function* () {
      const r = "/authorization-schema/get-roles", n = new URL(r, D);
      let s;
      t && (s = t.baseOptions);
      const i = Object.assign(Object.assign({ method: "GET" }, s), e), a = {}, o = {};
      Ye(i, t), yield Qe(a, t), L(n, o);
      let c = s && s.headers ? s.headers : {};
      return i.headers = Object.assign(Object.assign(Object.assign({}, a), c), e.headers), {
        url: q(n),
        options: i
      };
    }),
    getTenantConfiguration: (e, r = {}) => R(this, void 0, void 0, function* () {
      ge("getTenantConfiguration", "tenant", e);
      const n = "/authorization/get-configuration", s = new URL(n, D);
      let i;
      t && (i = t.baseOptions);
      const a = Object.assign(Object.assign({ method: "GET" }, i), r), o = {}, c = {};
      Ye(a, t), yield Qe(o, t), e !== void 0 && (c.tenant = e), L(s, c);
      let u = i && i.headers ? i.headers : {};
      return a.headers = Object.assign(Object.assign(Object.assign({}, o), u), r.headers), {
        url: q(s),
        options: a
      };
    }),
    hasPermissions: (e, r = {}) => R(this, void 0, void 0, function* () {
      ge("hasPermissions", "hasPermissionsBatchRequest", e);
      const n = "/authorization/has-permissions", s = new URL(n, D);
      let i;
      t && (i = t.baseOptions);
      const a = Object.assign(Object.assign({ method: "POST" }, i), r), o = {}, c = {};
      o["Content-Type"] = "application/json", L(s, c);
      let u = i && i.headers ? i.headers : {};
      return a.headers = Object.assign(Object.assign(Object.assign({}, o), u), r.headers), a.data = Re(e, a, t), {
        url: q(s),
        options: a
      };
    })
  };
}, fe = function(t) {
  const e = zn(t);
  return {
    getConditions(r) {
      return R(this, void 0, void 0, function* () {
        const n = yield e.getConditions(r);
        return $(n, g, j, t);
      });
    },
    getCurrentUserPermissions(r, n) {
      return R(this, void 0, void 0, function* () {
        const s = yield e.getCurrentUserPermissions(r, n);
        return $(s, g, j, t);
      });
    },
    getRoles(r) {
      return R(this, void 0, void 0, function* () {
        const n = yield e.getRoles(r);
        return $(n, g, j, t);
      });
    },
    getTenantConfiguration(r, n) {
      return R(this, void 0, void 0, function* () {
        const s = yield e.getTenantConfiguration(r, n);
        return $(s, g, j, t);
      });
    },
    hasPermissions(r, n) {
      return R(this, void 0, void 0, function* () {
        const s = yield e.hasPermissions(r, n);
        return $(s, g, j, t);
      });
    }
  };
};
class Jn extends ur {
  getConditions(e) {
    return fe(this.configuration).getConditions(e).then((r) => r(this.axios, this.basePath));
  }
  getCurrentUserPermissions(e, r) {
    return fe(this.configuration).getCurrentUserPermissions(e, r).then((n) => n(this.axios, this.basePath));
  }
  getRoles(e) {
    return fe(this.configuration).getRoles(e).then((r) => r(this.axios, this.basePath));
  }
  getTenantConfiguration(e, r) {
    return fe(this.configuration).getTenantConfiguration(e, r).then((n) => n(this.axios, this.basePath));
  }
  hasPermissions(e, r) {
    return fe(this.configuration).hasPermissions(e, r).then((n) => n(this.axios, this.basePath));
  }
}
class $t {
  constructor(e = {}) {
    this.apiKey = e.apiKey, this.username = e.username, this.password = e.password, this.accessToken = e.accessToken, this.basePath = e.basePath, this.baseOptions = e.baseOptions, this.formDataCtor = e.formDataCtor;
  }
  isJsonMime(e) {
    const r = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return e !== null && (r.test(e) || e.toLowerCase() === "application/json-patch+json");
  }
}
/*! api-interceptors 1.44.0 */
function Gn(t) {
  return (e) => ({
    ...e,
    withCredentials: t.corsCredentials
  });
}
function Yn(t) {
  const e = {
    "Content-Type": "application/json"
  };
  return {
    ...t,
    headers: {
      ...t.headers,
      ...e
    }
  };
}
function Qn(t) {
  return (e) => {
    const r = {
      ...e.headers,
      "x-applicationname": t
    };
    return {
      ...e,
      headers: r
    };
  };
}
function Xn() {
  const t = H();
  return new Promise((e) => {
    t.once("B2XCORE_AUTHENTICATION", (r) => {
      e(r.jwe || "");
    });
  });
}
function Wn(t) {
  return async (e) => {
    if (t && t.some((s) => {
      var i;
      return (i = e.url) == null ? void 0 : i.includes(s);
    }))
      return e;
    const r = await Xn(), n = r ? {
      ...e.headers,
      "authorization-jwe": `Bearer ${r}`
    } : { ...e.headers };
    return { ...e, headers: n };
  };
}
var me, Kn = new Uint8Array(16);
function Zn() {
  if (!me && (me = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !me))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return me(Kn);
}
const es = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function ts(t) {
  return typeof t == "string" && es.test(t);
}
var y = [];
for (var We = 0; We < 256; ++We)
  y.push((We + 256).toString(16).substr(1));
function rs(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (y[t[e + 0]] + y[t[e + 1]] + y[t[e + 2]] + y[t[e + 3]] + "-" + y[t[e + 4]] + y[t[e + 5]] + "-" + y[t[e + 6]] + y[t[e + 7]] + "-" + y[t[e + 8]] + y[t[e + 9]] + "-" + y[t[e + 10]] + y[t[e + 11]] + y[t[e + 12]] + y[t[e + 13]] + y[t[e + 14]] + y[t[e + 15]]).toLowerCase();
  if (!ts(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function lr(t, e, r) {
  t = t || {};
  var n = t.random || (t.rng || Zn)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    r = r || 0;
    for (var s = 0; s < 16; ++s)
      e[r + s] = n[s];
    return e;
  }
  return rs(n);
}
lr();
function ns(t) {
  const e = {
    ...t.headers,
    "X-TrackingId": lr() || ""
  };
  return {
    ...t,
    headers: e
  };
}
const ss = Gn, is = Yn, as = Qn, os = Wn, cs = ns;
async function M() {
  return new Promise((t) => {
    H().once(N, (e) => {
      t(e);
    });
  });
}
function Zs(t) {
  return H().subscribe(N, async (e) => {
    t(e);
  });
}
async function Te(t) {
  return await (t || H()).getConnectionDispatchers(
    N
  );
}
async function ei(t = "READY") {
  return new Promise((e) => {
    const r = H().subscribe(
      N,
      async (n) => {
        var s;
        ((s = n == null ? void 0 : n.meta) == null ? void 0 : s.status) === t && (setTimeout(() => {
          r == null || r.unsubscribe();
        }, 0), e(n));
      }
    );
  });
}
/*! connection-aem-environment 2.5.0 */
const dr = "OWC_AEM_ENV", us = new class extends Or {
  constructor() {
    super(dr);
  }
  get initialState() {
    var r, n, s, i, a, o;
    const t = ((r = window.aemNamespace) == null ? void 0 : r.environmentVariables) || ((s = (n = window.top) == null ? void 0 : n.aemNamespace) == null ? void 0 : s.environmentVariables), e = ((i = window.aemNamespace) == null ? void 0 : i.pageEnvironmentVariables) || ((o = (a = window.top) == null ? void 0 : a.aemNamespace) == null ? void 0 : o.pageEnvironmentVariables);
    return t && e ? { ...t, ...e } : {};
  }
  getReducer() {
    return () => this.initialState;
  }
  getPublicDispatchers() {
    return {};
  }
}(), ls = async () => {
  const t = H();
  return await (async () => {
    var e;
    if (!((e = window.top) != null && e.aemNamespace) && !window.aemNamespace)
      return new Promise((r) => {
        let n;
        Object.defineProperty(window.top, "aemNamespace", { get: () => n, async set(s) {
          n = s, r();
        } });
      });
  })(), await (async () => {
    var e, r, n;
    if (!((r = (e = window.top) == null ? void 0 : e.aemNamespace) != null && r.environmentVariables) && !((n = window == null ? void 0 : window.aemNamespace) != null && n.environmentVariables))
      return new Promise((s) => {
        var a;
        let i;
        Object.defineProperty((a = window.top) == null ? void 0 : a.aemNamespace, "environmentVariables", { get: () => i, set(o) {
          i = o, s();
        } });
      });
  })(), await (async () => {
    var e, r, n;
    if (!((r = (e = window.top) == null ? void 0 : e.aemNamespace) != null && r.pageEnvironmentVariables) && !((n = window == null ? void 0 : window.aemNamespace) != null && n.pageEnvironmentVariables))
      return new Promise((s) => {
        var a;
        let i;
        Object.defineProperty((a = window.top) == null ? void 0 : a.aemNamespace, "pageEnvironmentVariables", { get: () => i, set(o) {
          i = o, s();
        } });
      });
  })(), t.addConnection(us);
};
async function ds() {
  const t = H();
  try {
    await ls();
  } catch (e) {
    console.error(e);
  }
  return await new Promise((e) => {
    t.once(dr, (r) => {
      e(r);
    });
  });
}
const pe = ds(), V = {
  getAemEnvironment() {
    return pe;
  },
  async getCountry() {
    return (await pe).country;
  },
  async getLanguage() {
    return (await pe).language;
  },
  async getStage() {
    return (await pe).stage;
  },
  async getRunMode() {
    return (await pe).runMode;
  }
};
async function fs() {
  var t, e;
  const r = {}, n = await M();
  if (r.market = {
    domainRef: {
      code: await V.getCountry()
    }
  }, r.locale = {
    country: await V.getCountry(),
    language: await V.getLanguage()
  }, (t = n == null ? void 0 : n.user) != null && t.domainRef) {
    const { company: s, roles: i, userJourneyCache: a } = n;
    s && s.domainRef && (r.company = {
      domainRef: s == null ? void 0 : s.domainRef
    }), a && a.domainRef && (r.userJourneyCache = {
      domainRef: a == null ? void 0 : a.domainRef
    }), i && i.length && (r.roles = i.map((o) => ({
      domainRef: o.domainRef,
      context: o.context
    })));
  }
  return (e = n == null ? void 0 : n.vehicles) != null && e.length && (r.vehicles = n == null ? void 0 : n.vehicles.map((s) => ({
    domainRef: s.domainRef
  }))), r;
}
async function ps(t) {
  const e = await fs(), r = {
    ...t.headers,
    "B2X-ActiveProfile": JSON.stringify(e)
  };
  return {
    ...t,
    headers: r
  };
}
const hs = {
  XA: "AE-AZ",
  XD: "AE-DU"
}, ms = {
  toCountry(t) {
    const e = hs[t];
    return e || t;
  }
}, fr = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IN",
  "IE",
  "IT",
  "LV",
  "LI",
  "LT",
  "LU",
  "MT",
  "NL",
  "NO",
  "PL",
  "PT",
  "RO",
  "RU",
  "SK",
  "SI",
  "ZA",
  "ES",
  "SE",
  "CH",
  "TH",
  "TR",
  "GB",
  "AQ",
  "CN",
  "HK",
  "MO",
  "AE-AZ",
  "AE-DU"
], pr = ["AU", "BR", "CA", "JP", "MY", "MX", "NZ", "KR", "SG", "TW", "US"];
function vs(t) {
  const e = ms.toCountry(t);
  if (fr.includes(e))
    return "ECE";
  if (pr.includes(e))
    return "AMAP";
  throw new Error(`Country ${e} is not supported`);
}
function Es(t) {
  return t === "PROD" ? "PROD" : t === "PPROD" || t === "PREPROD" ? "PPROD" : "INT";
}
const ys = {
  ECE: {
    INT: {
      serverApiUrl: "https://services.me-int.mercedes-benz.com"
    },
    PPROD: {
      serverApiUrl: "https://services.me-int.mercedes-benz.com"
    },
    PROD: {
      serverApiUrl: "https://services.me.mercedes-benz.com"
    }
  },
  AMAP: {
    INT: {
      serverApiUrl: "https://services-amap.me-int.mercedes-benz.com"
    },
    PPROD: {
      serverApiUrl: "https://services-amap.me-int.mercedes-benz.com"
    },
    PROD: {
      serverApiUrl: "https://services-amap.me.mercedes-benz.com"
    }
  },
  CN: {
    INT: {
      serverApiUrl: "https://services.me-int.mercedes-benz.com"
    },
    PPROD: {
      serverApiUrl: "https://services.me-int.mercedes-benz.com"
    },
    PROD: {
      serverApiUrl: "https://services.me.mercedes-benz.com"
    }
  }
};
function Ps(t) {
  return t === "PROD" ? "" : t === "PPROD" || t === "PREPROD" ? "int." : "test.";
}
function gs(t) {
  if (fr.includes(t))
    return "emea";
  if (pr.includes(t))
    return "amap";
  throw new Error(`Country ${t} is not supported`);
}
function Os(t, e, r) {
  if (r)
    return `https://${Ps(e)}api.oneweb.mercedes-benz.com/mhb2b/${gs(t)}`;
  const n = vs(t), s = Es(e);
  return ys[n][s].serverApiUrl;
}
async function Rs(t) {
  const e = await V.getStage(), r = await V.getCountry();
  return {
    apiBasePath: Os(r, e, t),
    id: e
  };
}
const ws = {
  async getConfig(t) {
    return await Rs(t);
  }
};
async function bs(t, e) {
  const r = g.create();
  return r.interceptors.request.use(ps), r.interceptors.request.use(is), r.interceptors.request.use(cs), r.interceptors.request.use(as(e || "")), r.interceptors.request.use(os()), r.interceptors.request.use(ss(t)), r;
}
async function As(t, e) {
  const r = await ws.getConfig(t), n = await bs(r, e);
  return {
    profileApi: new $n(new qt(), `${r.apiBasePath}/services/api`, n),
    companyProfileApi: new Dn(
      new qt(),
      `${r.apiBasePath}/services/api`,
      n
    ),
    permissionsApi: new Jn(
      new $t(),
      `${r.apiBasePath}/permissions/mhb2b`,
      n
    ),
    activeUserProfileApi: new kn(
      new $t(),
      `${r.apiBasePath}/permissions/mhb2b`,
      n
    )
  };
}
const dt = {
  async getInstances(t, e = "b2xpal") {
    return await As(t, e);
  }
}, rt = async (t) => {
  var e, r, n, s, i;
  const a = {};
  (e = t.user) != null && e.domainRef && (a.user = {
    domainRef: t.user.domainRef
  }), (r = t.company) != null && r.domainRef ? a.company = {
    domainRef: t.company.domainRef
  } : t.company && (a.company = {}), (n = t.roles) != null && n.length && (a.roles = t.roles), (s = t.fleets) != null && s.length && (a.fleets = t.fleets.map((c) => ({ domainRef: c.domainRef }))), (i = t.vehicles) != null && i.length && (a.vehicles = t.vehicles.map((c) => ({ domainRef: c.domainRef })));
  const { activeUserProfileApi: o } = await dt.getInstances("MHB2B");
  await o.saveCurrentActiveUserProfile({ activeUserProfile: a });
}, Cs = (t) => ({ ...t }), Ss = (t) => ({ ...t });
var we = "NOT_FOUND";
function Ts(t) {
  var e;
  return {
    get: function(n) {
      return e && t(e.key, n) ? e.value : we;
    },
    put: function(n, s) {
      e = {
        key: n,
        value: s
      };
    },
    getEntries: function() {
      return e ? [e] : [];
    },
    clear: function() {
      e = void 0;
    }
  };
}
function _s(t, e) {
  var r = [];
  function n(o) {
    var c = r.findIndex(function(l) {
      return e(o, l.key);
    });
    if (c > -1) {
      var u = r[c];
      return c > 0 && (r.splice(c, 1), r.unshift(u)), u.value;
    }
    return we;
  }
  function s(o, c) {
    n(o) === we && (r.unshift({
      key: o,
      value: c
    }), r.length > t && r.pop());
  }
  function i() {
    return r;
  }
  function a() {
    r = [];
  }
  return {
    get: n,
    put: s,
    getEntries: i,
    clear: a
  };
}
var Us = function(e, r) {
  return e === r;
};
function Ns(t) {
  return function(r, n) {
    if (r === null || n === null || r.length !== n.length)
      return !1;
    for (var s = r.length, i = 0; i < s; i++)
      if (!t(r[i], n[i]))
        return !1;
    return !0;
  };
}
function Bs(t, e) {
  var r = typeof e == "object" ? e : {
    equalityCheck: e
  }, n = r.equalityCheck, s = n === void 0 ? Us : n, i = r.maxSize, a = i === void 0 ? 1 : i, o = r.resultEqualityCheck, c = Ns(s), u = a === 1 ? Ts(c) : _s(a, c);
  function l() {
    var f = u.get(arguments);
    if (f === we) {
      if (f = t.apply(null, arguments), o) {
        var d = u.getEntries(), m = d.find(function(k) {
          return o(k.value, f);
        });
        m && (f = m.value);
      }
      u.put(arguments, f);
    }
    return f;
  }
  return l.clearCache = function() {
    return u.clear();
  }, l;
}
function xs(t) {
  var e = Array.isArray(t[0]) ? t[0] : t;
  if (!e.every(function(n) {
    return typeof n == "function";
  })) {
    var r = e.map(function(n) {
      return typeof n == "function" ? "function " + (n.name || "unnamed") + "()" : typeof n;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + r + "]");
  }
  return e;
}
function js(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
    r[n - 1] = arguments[n];
  var s = function() {
    for (var a = arguments.length, o = new Array(a), c = 0; c < a; c++)
      o[c] = arguments[c];
    var u = 0, l, f = {
      memoizeOptions: void 0
    }, d = o.pop();
    if (typeof d == "object" && (f = d, d = o.pop()), typeof d != "function")
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof d + "]");
    var m = f, k = m.memoizeOptions, A = k === void 0 ? r : k, x = Array.isArray(A) ? A : [A], C = xs(o), B = t.apply(void 0, [function() {
      return u++, d.apply(null, arguments);
    }].concat(x)), v = t(function() {
      for (var p = [], ce = C.length, ue = 0; ue < ce; ue++)
        p.push(C[ue].apply(null, arguments));
      return l = B.apply(null, p), l;
    });
    return Object.assign(v, {
      resultFunc: d,
      memoizedResultFunc: B,
      dependencies: C,
      lastResult: function() {
        return l;
      },
      recomputations: function() {
        return u;
      },
      resetRecomputations: function() {
        return u = 0;
      }
    }), v;
  };
  return s;
}
var he = /* @__PURE__ */ js(Bs);
const ft = "B2B", hr = "B2C", ti = [ft, hr], mr = (t) => t.activeCustomerGroup, Vs = (t) => t.user, Is = (t) => t.company, ri = (t) => {
  var e;
  return Boolean(((e = t.meta) == null ? void 0 : e.status) === "READY");
}, Ds = he([mr], (t) => {
  var e;
  return (e = t == null ? void 0 : t.domainRef) == null ? void 0 : e.id;
}), Ls = he([mr], (t) => t == null ? void 0 : t.customerType), vr = he(
  [Ls],
  (t) => t == null ? void 0 : t.businessType
), Ft = (t) => !!t && Object.keys(t).length === 0, ni = he(
  [vr, Vs, Is],
  (t, e, r) => t === ft && Ft(r) || t === hr && Ft(e)
), si = he(
  [vr, Ds],
  (t, e) => ({
    businessType: t,
    customerGroupId: e
  })
), F = kt("B2X-PAL"), Er = async (t) => {
  var e;
  const r = await M(), n = await Te(), { user: s, roles: i, fleets: a, vehicles: o, activeCustomerGroup: c, company: u, permissions: l, meta: f } = t, d = { ...r.meta, ...f }, m = { ...r, meta: d, activeCustomerGroup: c, company: u };
  s && (m.user = s), (e = l == null ? void 0 : l.actionPermissions) != null && e.length && (m.permissions = {
    ...m.permissions,
    actionPermissions: l == null ? void 0 : l.actionPermissions
  }), i && i.length && (m.roles = i), a != null && a.length && (m.fleets = a), o != null && o.length && (m.vehicles = o), n.setState(m);
}, pt = async ({
  userToken: t,
  businessType: e,
  marketId: r,
  ensureProperties: n,
  overrideIncludeDescriptors: s
}) => {
  const { activeUserProfileApi: i } = await dt.getInstances("MHB2B"), a = t ? { "authorization-jwe": `Bearer ${t}` } : {}, { data: o } = await i.getActiveUserProfile(
    {
      requests: [
        {
          fspRequest: {
            filterDescriptor: {
              entityType: "ActiveUserProfile"
            },
            includeDescriptor: {
              includedPropertyPaths: s != null && s.length ? s : [
                .../* @__PURE__ */ new Set([
                  "activeCustomerGroup.**",
                  "company.domainRef.**",
                  "company.customerGroups.**",
                  "company.name",
                  "permissions.actionPermissions.domainRef.**",
                  "roles.domainRef.**",
                  "fleets.domainRef.**",
                  "user.domainRef.**",
                  "user.displayName",
                  "user.companies.name",
                  "user.companies.domainRef.**",
                  "onBehalfOfUser.domainRef.**",
                  "vehicles.domainRef.**",
                  ...n || []
                ])
              ]
            }
          },
          marketId: { code: r || await V.getCountry() },
          customerBusinessType: e
        }
      ]
    },
    a
  );
  return o;
}, se = async ({
  userToken: t,
  businessType: e,
  marketId: r,
  lastSelectedCompanyProfileId: n,
  ensureProperties: s
}, i = !0) => {
  F.debug("Getting active user profile, version=1.44.0");
  const a = await pt({
    userToken: t,
    businessType: e,
    marketId: r,
    ensureProperties: s
  }), o = await Fs(
    { userToken: t, lastSelectedCompanyProfileId: n, marketId: r, ensureProperties: s },
    a == null ? void 0 : a.responses[0].items
  );
  if (o)
    if (o.meta = { version: "1.44.0", status: "READY" }, i)
      F.debug(`Now setting the status with ${JSON.stringify(o)}`), await Er(o);
    else
      return o;
}, qs = async ({ ensureProperties: t } = {}) => {
  await se({
    userToken: "",
    businessType: Y.B2B,
    marketId: "",
    ensureProperties: t
  });
}, $s = async ({ ensureProperties: t } = {}) => {
  await se({
    userToken: "",
    businessType: Y.B2C,
    marketId: "",
    ensureProperties: t
  });
}, Mt = async () => {
  var t;
  let e = await M();
  const r = await pt({
    overrideIncludeDescriptors: ["roles.domainRef.**", "permissions.actionPermissions.domainRef.**"],
    businessType: e.company ? Y.B2B : Y.B2C
  });
  e = await M();
  const n = await Te(), { roles: s, permissions: i } = r.responses[0].items[0], a = { ...e };
  s != null && s.length && (a.roles = [...s]), (t = i == null ? void 0 : i.actionPermissions) != null && t.length && (a.permissions = {
    ...a.permissions,
    actionPermissions: i == null ? void 0 : i.actionPermissions
  }), n.setState(a);
}, yr = async (t, e, r, n, s) => {
  await rt({ ...G(), user: n, company: s });
  const i = await pt({ userToken: t, marketId: e, ensureProperties: r });
  return { ...G(), ...i == null ? void 0 : i.responses[0].items[0] };
}, Fs = async ({ userToken: t, lastSelectedCompanyProfileId: e, marketId: r, ensureProperties: n }, s = []) => {
  var i, a;
  const o = await Ms(s, t, r, n);
  try {
    if (t && ((i = o.activeCustomerGroup) == null ? void 0 : i.customerType.businessType) == ft && e && ((a = o.company) == null ? void 0 : a.domainRef) != e)
      return F.debug(`Trying to select the previous company ${e}`), yr(t, r, n, o.user, {
        domainRef: { meId: e }
      });
  } catch (c) {
    F.error("While checking current active", c);
  }
  return o;
}, Ms = async (t, e, r, n) => {
  var s, i;
  const a = t.reduce(
    (o, c) => {
      var u;
      return c.company ? c.company.domainRef ? o.B2B.REAL.push(c) : o.B2B.ANON.push(c) : (u = c.user) != null && u.domainRef ? o.B2C.REAL.push(c) : o.B2C.ANON.push(c), o;
    },
    {
      B2B: { ANON: [], REAL: [] },
      B2C: { ANON: [], REAL: [] }
    }
  );
  if (a.B2C.REAL.length > 0)
    return F.debug("Selecting the B2C profile"), {
      ...G(),
      ...a.B2C.REAL[0]
    };
  if (a.B2C.ANON.length > 0)
    return F.debug("Selecting the B2C anonymous"), {
      ...G(),
      ...a.B2C.ANON[0]
    };
  if (a.B2B.REAL.length == 1)
    return F.debug("Selecting the unique B2B profile"), {
      ...G(),
      ...a.B2B.REAL[0]
    };
  if (a.B2B.ANON.length == 1 && ((i = (s = a.B2B.ANON[0].user) == null ? void 0 : s.companies) == null ? void 0 : i.length) == 1) {
    const o = a.B2B.ANON[0].user, c = (o == null ? void 0 : o.companies) && o.companies[0];
    return yr(e, r, n, o, c);
  }
  return F.debug("B2B mode without explicit company selection, reverting to default"), {
    ...G(),
    ...a.B2B.ANON[0]
  };
};
var ve, Hs = new Uint8Array(16);
function ks() {
  if (!ve && (ve = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !ve))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ve(Hs);
}
const zs = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Js(t) {
  return typeof t == "string" && zs.test(t);
}
var P = [];
for (var Ke = 0; Ke < 256; ++Ke)
  P.push((Ke + 256).toString(16).substr(1));
function Gs(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (P[t[e + 0]] + P[t[e + 1]] + P[t[e + 2]] + P[t[e + 3]] + "-" + P[t[e + 4]] + P[t[e + 5]] + "-" + P[t[e + 6]] + P[t[e + 7]] + "-" + P[t[e + 8]] + P[t[e + 9]] + "-" + P[t[e + 10]] + P[t[e + 11]] + P[t[e + 12]] + P[t[e + 13]] + P[t[e + 14]] + P[t[e + 15]]).toLowerCase();
  if (!Js(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function Ys(t, e, r) {
  t = t || {};
  var n = t.random || (t.rng || ks)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    r = r || 0;
    for (var s = 0; s < 16; ++s)
      e[r + s] = n[s];
    return e;
  }
  return Gs(n);
}
function Ht() {
  return {
    domainRef: {
      id: Ys()
    }
  };
}
const Ee = kt("B2X-PAL");
class Qs extends Rr {
  constructor() {
    super(N);
  }
  get initialState() {
    return Ee.log("Connection initialized with version: 1.44.0"), G();
  }
  getReducer() {
    return (e, r) => {
      switch (r.type) {
        case this.getActionType(h.SET_COMPANY):
          return {
            ...e,
            company: r.payload,
            activeCustomerGroup: void 0,
            roles: [],
            fleets: [],
            vehicles: [],
            permissions: {},
            userJourneyCache: Ht(),
            ensureProperties: [],
            meta: {
              ...e.meta,
              actionPermissions: []
            }
          };
        case this.getActionType(h.UPDATE_COMPANY):
          return {
            ...e,
            company: r.payload
          };
        case this.getActionType(h.SET_USER):
          return {
            ...e,
            user: r.payload
          };
        case this.getActionType(h.SET_FLEETS):
          return {
            ...e,
            fleets: r.payload
          };
        case this.getActionType(h.SET_VEHICLES):
          return {
            ...e,
            vehicles: r.payload
          };
        case this.getActionType(h.SET_VEHICLE_COUNT):
          return {
            ...e,
            company: {
              ...e.company,
              vehicleCount: r.payload
            }
          };
        case this.getActionType(h.SET_ROLES):
          return {
            ...e,
            roles: r.payload
          };
        case this.getActionType(h.SET_USER_JOURNEY_CACHE):
          return {
            ...e,
            userJourneyCache: r.payload
          };
        case this.getActionType(h.REGENERATE_USER_JOURNEY_CACHE):
          return {
            ...e,
            userJourneyCache: Ht(),
            ensureProperties: []
          };
        case this.getActionType(h.SET_ACTION_PERMISSIONS):
          return {
            ...e,
            permissions: {
              ...e.permissions,
              actionPermissions: r.payload
            }
          };
        case this.getActionType(h.SET_SERVICE_PERMISSIONS):
          return {
            ...e,
            permissions: {
              ...e.permissions,
              servicePermissions: r.payload
            }
          };
        case this.getActionType(h.SET_ENTITY_PERMISSIONS):
          return {
            ...e,
            permissions: {
              ...e.permissions,
              entityPermissions: r.payload
            }
          };
        case this.getActionType(h.SET_ACTIVE_COSTUMER_GROUP):
          return {
            ...e,
            activeCustomerGroup: r.payload
          };
        case this.getActionType(h.ENSURE_PROPERTIES):
          return {
            ...e,
            ensureProperties: [.../* @__PURE__ */ new Set([...e.ensureProperties || [], ...r.payload])]
          };
        case this.getActionType(h.SET_STATE):
          return {
            ...e,
            ...r.payload
          };
        case this.getActionType(h.RESET_STATE):
          return { ...e };
        default:
          return e;
      }
    };
  }
  getPublicDispatchers() {
    return {
      setCompany: (e, r = [], n = [], s = !0, i) => async (a, o) => {
        if (a(this.getAction(h.SET_COMPANY, e)), n != null && n.length)
          a(this.getAction(h.SET_ROLES, r)), a(this.getAction(h.SET_ACTION_PERMISSIONS, n));
        else
          try {
            await Mt();
          } catch (c) {
            Ee.error("Could not load permissions ... ", c);
          }
        await this.postDispatcherCall(s, o, i);
      },
      setActiveUserProfile: (e) => async (r, n) => {
        const s = n()[N];
        if (!e.companyProfileId || e.businessType === Y.B2C) {
          const i = await se(
            {
              ...e,
              ensureProperties: [...(s == null ? void 0 : s.ensureProperties) || [], ...e.ensureProperties || []]
            },
            !1
          );
          if (!i)
            return;
          await Er(i);
        } else {
          const i = {
            company: {
              domainRef: {
                meId: e.companyProfileId
              }
            }
          };
          await rt(i), await se({
            ...e,
            ensureProperties: [...(s == null ? void 0 : s.ensureProperties) || [], ...e.ensureProperties || []]
          });
        }
      },
      setUser: (e, r = !0, n) => async (s, i) => {
        s(this.getAction(h.SET_USER, e)), await this.postDispatcherCall(r, i, n);
      },
      setFleets: (e, r = !0, n) => async (s, i) => {
        s(this.getAction(h.SET_FLEETS, e)), await this.postDispatcherCall(!1, i, n);
      },
      setVehicles: (e, r = !0, n) => async (s, i) => {
        if (s(this.getAction(h.SET_VEHICLES, e)), r)
          try {
            await Mt();
          } catch (a) {
            Ee.error("Could not load permissions ... ", a);
          }
        await this.postDispatcherCall(!1, i, n);
      },
      setVehicleCount: (e) => this.getAction(h.SET_VEHICLE_COUNT, e),
      setUserJourneyCache: (e) => this.getAction(h.SET_USER_JOURNEY_CACHE, e),
      regenerateUserJourneyCache: () => this.getAction(h.REGENERATE_USER_JOURNEY_CACHE),
      setActiveCustomerGroup: (e) => this.getAction(h.SET_ACTIVE_COSTUMER_GROUP, e),
      resetState: () => this.getAction(h.RESET_STATE),
      setState: (e) => this.getAction(h.SET_STATE, e),
      loadLastStateFromBE: (e, r) => async (n, s) => {
        var i;
        await se({
          ensureProperties: (i = s()[N]) == null ? void 0 : i.ensureProperties,
          ...e
        }), await this.postDispatcherCall(!1, s, r);
      },
      loadLastB2CStateFromBE: (e) => async (r, n) => {
        var s;
        await $s({
          ensureProperties: (s = n()[N]) == null ? void 0 : s.ensureProperties
        }), await this.postDispatcherCall(!1, n, e);
      },
      loadLastB2BStateFromBE: (e) => async (r, n) => {
        var s;
        await qs({
          ensureProperties: (s = n()[N]) == null ? void 0 : s.ensureProperties
        }), await this.postDispatcherCall(!1, n, e);
      },
      ensureProperties: (e, r) => async (n, s) => {
        n(this.getAction(h.ENSURE_PROPERTIES, e));
        const i = s()[N], a = [];
        (i.ensureProperties || []).forEach((o) => {
          const c = Sr(i, o.replaceAll(".*", "").replaceAll(".**", ""));
          c == null && a.push(o);
        }), a.length && await se({
          ensureProperties: e,
          businessType: i.company ? Y.B2B : Y.B2C
        }), await this.postDispatcherCall(!1, s, r);
      }
    };
  }
  get storageType() {
    return "session";
  }
  loadPersistedStateCallback(e) {
    return this.getAction(
      h.SET_STATE,
      Cs({
        ...e,
        meta: {
          ...e.meta,
          version: "1.44.0",
          status: "INITIALIZING"
        }
      })
    );
  }
  transformToPersistentState(e) {
    return Ss(e);
  }
  async postDispatcherCall(e, r, n) {
    const { persistBE: s } = e === !0 ? { persistBE: !0 } : e || { persistBE: !1 };
    Ee.debug(`post dispatcher, persistBE=${s}, / opts=${JSON.stringify(e)}`);
    const i = r()[N];
    s && await rt(i), n && typeof n == "function" && n(i);
  }
}
const ii = (t) => (t || H()).addConnection(new Qs());
async function ai(t) {
  const e = await M();
  if (!e || !e.permissions || !e.permissions.actionPermissions)
    return !1;
  const r = t.toLowerCase();
  return (e.permissions.actionPermissions || []).some(
    (n) => Xs(n, r)
  );
}
const Xs = (t, e) => {
  var r, n, s, i, a, o;
  let c = "";
  (r = t.domainRef) != null && r.tenant && (c = ((n = t.domainRef) == null ? void 0 : n.tenant.mbocId) || ((s = t.domainRef) == null ? void 0 : s.tenant.onewebId) || "");
  let u = c ? `${c}.${(i = t.domainRef) == null ? void 0 : i.name}` : (a = t.domainRef) == null ? void 0 : a.name;
  return u && (u = (o = t.domainRef) == null ? void 0 : o.id), (u || "").toLowerCase() === e;
};
async function Pr(t) {
  if (t.length === 0)
    return [];
  const e = await Te(), r = await M(), { company: n, fleets: s, user: i, onBehalfOfUser: a, vehicles: o, roles: c, meta: u } = r, { permissionsApi: l } = await dt.getInstances("MHB2B"), f = t.map((v) => ({ name: v.toLocaleLowerCase() })), d = (u == null ? void 0 : u.actionPermissions) || [], m = d && d.length > 0 ? f.filter(
    (v) => !d.some((T) => v.name === T.name)
  ) : f;
  if (m.length === 0)
    return d;
  const A = (await l.hasPermissions({
    requests: [
      {
        activeUserProfile: {
          market: { code: await V.getCountry() },
          locale: {
            country: await V.getCountry(),
            language: await V.getLanguage()
          },
          company: n == null ? void 0 : n.domainRef,
          fleets: s == null ? void 0 : s.map((v) => v.domainRef),
          user: i == null ? void 0 : i.domainRef,
          onBehalfOfUser: a == null ? void 0 : a.domainRef,
          vehicles: o == null ? void 0 : o.map((v) => v.domainRef),
          roles: c == null ? void 0 : c.map((v) => v.domainRef)
        },
        actionPermissions: m
      }
    ]
  })).data.responses[0].actionPermissions || [], x = m.map((v) => {
    const T = v.name.split(":").pop(), p = A.find((ce) => ce.name === T);
    return {
      ...v,
      status: Boolean(p)
    };
  }), C = [...d, ...x], B = {
    ...r,
    meta: {
      ...r.meta,
      actionPermissions: C
    }
  };
  return e.setState(B), C;
}
async function oi(t) {
  const { meta: e } = await M();
  if (e != null && e.actionPermissions) {
    const r = e.actionPermissions.find((i) => i.name === t);
    if (r)
      return r.status;
    const s = (await Pr([t])).find((i) => i.name === t);
    if (s)
      return s.status;
  }
  return !1;
}
async function ci() {
  const t = await Te(), e = await M(), { meta: r } = e;
  if ((r == null ? void 0 : r.actionPermissions) && r.actionPermissions.length > 0) {
    const n = r.actionPermissions, s = {
      ...e,
      meta: { ...e.meta, actionPermissions: [] }
    };
    t.setState(s);
    const i = n.map((o) => o.name);
    return await Pr(i);
  }
  return [];
}
export {
  ps as ActiveProfileInterceptor,
  ft as B2B_BUSINESS_TYPE,
  hr as B2C_BUSINESS_TYPE,
  Qs as B2XActiveUserConnection,
  N as B2X_ACTIVE_PROFILE_CONNECTION_NAME,
  ti as BusinessTypes,
  fs as activeProfileInterceptorStructure,
  V as aemHelper,
  si as basicInfoSelector,
  vr as businessTypeSelector,
  Is as companySelector,
  Ds as customerGroupIdSelector,
  mr as customerGroupSelector,
  Ls as customerTypeSelector,
  M as getActiveProfile,
  Te as getActiveProfileDispatchers,
  ei as getReadyActiveProfile,
  ai as hasActionPermission,
  oi as hasPermission,
  ri as isActiveProfileReady,
  ni as isAnonymousSelector,
  Pr as loadPermissions,
  ci as reloadPermissions,
  ii as setupActiveProfileConnection,
  Zs as subscribeToActiveProfile,
  Vs as userSelector
};
//# sourceMappingURL=index.mjs.map
